"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMultiImagePicker = exports.useTabs = exports.useClickOutsideContainer = void 0;
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
/**
 * Alert clicks outside of the passed ref.
 * @param ref React ref to which the click outside will be measured.
 * @param callback Callback to execute once the click outside happens (optional).
 * @returns A flag indicating if the user clicked or not outside the passed ref component.
 */
function useClickOutsideContainer(ref, callback) {
    var _a = (0, react_1.useState)(false), clickedOutside = _a[0], setClickedOutside = _a[1];
    (0, react_1.useEffect)(function () {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback && callback(event);
                setClickedOutside(true);
            }
        }
        //@ts-ignore
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            //@ts-ignore
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, clickedOutside, callback]);
    return clickedOutside;
}
exports.useClickOutsideContainer = useClickOutsideContainer;
/**
 * Provides state logic management and a click handler for creating a
 * Tabs component.
 * @param content Array of tabs, in which it is specified the tab
 * label and component to render on active mode.
 * @returns Current tabs status and the tab click handler.
 */
function useTabs(tabIds) {
    var _a = (0, react_1.useState)(getInitialConfigs()), tabs = _a[0], setTabs = _a[1];
    var handleTabClick = (0, react_1.useCallback)(function (tabId) {
        return setTabs(function (prevTabs) {
            return prevTabs.map(function (tab) {
                if (tab._id === tabId) {
                    return __assign(__assign({}, tab), { isActive: true });
                }
                return __assign(__assign({}, tab), { isActive: false });
            });
        });
    }, []);
    function getInitialConfigs() {
        if (tabIds.length <= 0)
            return [];
        return tabIds.map(function (_id, index) {
            if (index === 0) {
                return {
                    _id: _id,
                    isActive: true,
                };
            }
            return {
                _id: _id,
                isActive: false,
            };
        });
    }
    return { tabs: tabs, handleTabClick: handleTabClick };
}
exports.useTabs = useTabs;
/**
 * Provides state logic management for images import.
 * @param images - Images to manage. Takes an empty array by default.
 * @param setImages - Dispatcher for images prop.
 * @param options - Configs for the dropzone.
 * @param onDropRejected - Callback to execute when an img drop fails.
 * @returns The images being managed, a function to remove them
 * externally and a general picker wrapper component.
 */
function useMultiImagePicker(_a) {
    var _b = _a.images, images = _b === void 0 ? [] : _b, setImages = _a.setImages, options = _a.options, onDropRejected = _a.onDropRejected;
    var ImagePicker = function (_a) {
        var children = _a.children;
        var _b = (0, react_dropzone_1.useDropzone)(__assign(__assign({}, options), { accept: "image/*", onDrop: function (acceptedFiles) {
                setImages(__spreadArray(__spreadArray([], images, true), acceptedFiles.map(function (image) {
                    return Object.assign(image, {
                        preview: URL.createObjectURL(image),
                    });
                }), true));
            }, onDropRejected: function (event) {
                onDropRejected && onDropRejected(event);
            } })), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps;
        return (react_1.default.createElement("div", __assign({}, getRootProps({ className: "dropzone" }), { style: { width: "fit-content" } }),
            react_1.default.createElement("input", __assign({}, getInputProps())),
            children));
    };
    function removeImage(selectedImage) {
        setImages(images.filter(function (image) {
            if (image.file) {
                return selectedImage.file
                    ? selectedImage.file.name !== image.file.name
                    : true;
            }
            return "_id" in selectedImage ? selectedImage._id !== image._id : true;
        }));
    }
    (0, react_1.useEffect)(function () { return function () {
        images.forEach(function (image) {
            image.file && URL.revokeObjectURL(image.file.preview);
        });
    }; }, [images]);
    return { ImagePicker: ImagePicker, images: images, removeImage: removeImage };
}
exports.useMultiImagePicker = useMultiImagePicker;
//# sourceMappingURL=index.js.map